// @ts-nocheck
class StaticTabsManager extends HTMLElement {
    constructor() {
        super();
        this.activeTabIndex = -1;
    }

    connectedCallback() {
        requestAnimationFrame(() => {
            this.initTabClicks();
            this.initFirstTab();
        });
    }

    /**
     * Initialize click handlers
     */
    initTabClicks() {
        this.querySelectorAll('[data-tab-button]').forEach((button, index) => {
            button.addEventListener('click', () => {
                this.switchTab(index, button);
            });
        });
    }

    /**
     * Activate first tab on load
     */
    initFirstTab() {
        const firstButton = this.querySelector('[data-tab-button]');
        if (firstButton) {
            this.switchTab(0, firstButton);
        }
    }

    /**
     * Switch tab
     */
    switchTab(tabIndex, button) {
        if (this.activeTabIndex === tabIndex) return;

        const buttons = this.querySelectorAll('[data-tab-button]');
        const contents = this.querySelectorAll('[data-tab-content]');

        // Update buttons
        buttons.forEach(btn => btn.classList.remove('active'));
        button.classList.add('active');

        // Update contents
        contents.forEach((content, index) => {
            if (index === tabIndex) {
                content.classList.remove('hidden');
                content.classList.add('active');

                this.ensureSwiperReady(content);

            } else {
                content.classList.add('hidden');
                content.classList.remove('active');
            }
        });

        this.activeTabIndex = tabIndex;
    }

    /**
     * Update card content from active slide (FIXED HERE)
     */
    updateContentFromSlide(swiperInstance) {
        if (!swiperInstance || !swiperInstance.slides) return;

        const activeSlide = swiperInstance.slides[swiperInstance.activeIndex];
        if (!activeSlide) return;

        // 🔥 FIX: scope to active tab only
        const activePanel = this.querySelector('[data-tab-content].active');

        const titleEl = activePanel?.querySelector('[data-id-content-title]');
        const descEl = activePanel?.querySelector('[data-id-content-desc]');
        const linkEl = activePanel?.querySelector('[data-id-content-link]');
        const linkTextEl = activePanel?.querySelector('[data-id-content-link-text]');

        const setTitle = activeSlide.dataset.setTitle;
        const setDesc = activeSlide.dataset.setDesc;
        const setLink = activeSlide.dataset.setLink;
        const setLinkText = activeSlide.dataset.setLinkText;

        if (titleEl) titleEl.textContent = setTitle || '';
        if (descEl) descEl.textContent = setDesc || '';
        if (linkEl && setLink) linkEl.href = setLink;
        if (linkTextEl) linkTextEl.textContent = setLinkText || '';
    }

    /**
     * Ensure swiper is ready
     */
    ensureSwiperReady(contentPanel) {
        const swiperComp = contentPanel.querySelector('swiper-component');
        if (!swiperComp || typeof swiperComp.init !== 'function') return;

        let swiperInstance = swiperComp.getSwiper?.();

        // If not initialized → init
        if (!swiperInstance) {
            swiperComp.init();
            swiperInstance = swiperComp.getSwiper();
        }

        // 🔥 ALWAYS attach listener (once)
        if (swiperInstance && !swiperInstance._tabListenerAttached) {
            swiperInstance.on('slideChange', (swiper) => {
                this.updateContentFromSlide(swiper);
            });
            swiperInstance._tabListenerAttached = true;
        }

        // Update layout
        requestAnimationFrame(() => {
            swiperInstance?.update();
        });

        // Initial content sync
        this.updateContentFromSlide(swiperInstance);
    }
}

if (!customElements.get('static-tabs-manager')) {
    customElements.define('static-tabs-manager', StaticTabsManager);
}